module.exports = __webpack_public_path__ + "img/frame (163).96301810.jpg";